// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"TextArea_textareaWrapper__iZZUz","fillTextarea":"TextArea_fillTextarea__1SG8e"};